import * as types from "../actions/ActionTypes";
import {dogInitials} from "../store/InitialStore";

export default function Dogreducer(state = dogInitials, action) {
  const { type, payload,} = action;
  switch (type) {

    case types.DOG_LIST:
        return [...state,...payload]

    default:
    return state;
  }
}
